export * from './fade-in.animation';
// export * from './fly-in-out.animation';
export * from './enter-left.animation';


// WEBPACK FOOTER //
// /Users/samantha/Documents/samanthaApp/src/app/shared/animations/index.ts